var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { AppState } from "@/share/AppState";
import { action, makeObservable, observable } from "mobx";
export class DatasheetStore {
    constructor() {
        this.schemas = new Map();
        this.loading = false;
        this.activedid = "";
        this.myzindex = -1;
        this.activelterid = "";
        this.initdsheet = "";
        this.showmenu = false;
        makeObservable(this);
        APPEvent.addSubscriberForAppState((st) => {
            if (st === AppState.LoggedIn) {
                this.reset();
            }
        });
        APPEvent.addSubscriberForDeleteDatasheet((dh) => {
            if (dh.ok) {
                this.removeDatasheet(dh.id);
            }
        });
        APPEvent.addSubscriberForActiveLetr((letr) => {
            if (this.activelterid !== letr) {
                this.activelterid = letr;
                this.reset();
                this.setLoading(true);
                this.loadDatasheet();
            }
        });
        APPEvent.addSubscriberForGetDatasheet((schs) => {
            for (const sch of schs) {
                if (sch.letrid === this.activelterid) {
                    this.addDatasheet(sch);
                }
            }
            if (this.loading && this.initdsheet) {
                this.setActiveDatasheet(this.initdsheet);
            }
            this.initdsheet = "";
            this.setLoading(false);
        });
        APPEvent.addSubscriberForAddDatasheet((sh) => {
            if (sh.sh && sh.sh.letrid === this.activelterid) {
                this.addDatasheet(sh.sh);
            }
        });
        APPEvent.addSubscriberForUpdateDatasheet((up) => {
            if (up.ok) {
                this.addDatasheet(up.sch);
            }
        });
    }
    setShowMenu(show) {
        this.showmenu = show;
    }
    setMyZindex(index) {
        this.myzindex = index;
    }
    addDatasheet(sch) {
        this.schemas.set(sch.id, sch);
    }
    loadDatasheet() {
        const req = {
            letrid: this.activelterid,
            datasheetid: this.activedid
        };
        Apphandler.sendMessage("getdatasheets", req);
    }
    getDatasheet(id) {
        return this.schemas.get(id);
    }
    setActiveDatasheet(id) {
        this.activedid = id;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    removeDatasheet(id) {
        this.schemas.delete(id);
    }
    reset() {
        this.schemas.clear();
        this.setLoading(false);
        this.setActiveDatasheet("");
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], DatasheetStore.prototype, "schemas", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetStore.prototype, "activedid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetStore.prototype, "myzindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetStore.prototype, "showmenu", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DatasheetStore.prototype, "setMyZindex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DatasheetStore.prototype, "addDatasheet", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DatasheetStore.prototype, "setActiveDatasheet", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DatasheetStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DatasheetStore.prototype, "removeDatasheet", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DatasheetStore.prototype, "reset", null);
